import { render, staticRenderFns } from "./VariableInterestView.vue?vue&type=template&id=1ff6a1b1&lang=pug&"
import script from "./VariableInterestView.vue?vue&type=script&lang=js&"
export * from "./VariableInterestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports